import makeStyles from '@ui/utils/makeStyles';


export default makeStyles()((theme) => ({
  heroWrapper: {
    width: '100vw',
    position: 'relative',
    left: '50%',
    transform: 'translateX(-50%)',
    maxWidth: 'none',
    height: 477,
    [theme.breakpoints.up('md')]: {
      height: 642,
    }
  },
  heroBackground: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    backgroundPosition: 'center',
    zIndex: 0,
    borderRadius: 0,
    backgroundSize: 'cover',
  },
  heroTextContainer: {
    color: theme.palette.common.white,
    textAlign: 'left',
    position: 'absolute',
    width: '100%',
    maxWidth: '1260px',
    transform: 'translateX(-50%)',
    left: '50%',
    height: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    flexDirection: 'column',
    top: 0,
    zIndex: 2,
    padding: theme.spacing(0, 2, 0),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 0, 0)
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 0, 11.25, 0)
    },
  },
  heroText: {
    fontSize: 40,
    lineHeight: 1,
    fontWeight: 500,
    letterSpacing: '-3px',
    [theme.breakpoints.up('md')]: {
      fontSize: 72
    }
  },
  subText: {
    fontSize: 18,
    lineHeight: 1.5,
    fontWeight: 500,
    marginBottom: '30px',
    [theme.breakpoints.up('md')]: {
      fontSize: 24,
      marginBottom: '60px',
      maxWidth: '685px',
    }
  },
  heroOverlay: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    backgroundImage: 'linear-gradient(to bottom, rgba(8, 8, 8, 0.0) 0%, rgba(8, 8, 8, 0.6) 100%)',
    zIndex: 1,
    [theme.breakpoints.up('md')]: {
      backgroundImage: 'linear-gradient(to bottom, rgba(8, 8, 8, 0.0) 0%, rgba(8, 8, 8, 0.3) 100%)',
    }
  },
  textField: {
    fontSize: 14,
    width: 'auto',
    flex: 1,
    '& input:placeholder': {
      color: '#666 !important'
    }
  },
  submitButton: {
    whiteSpace: 'nowrap',
    position: 'absolute',
    top: 'calc(100% + 10px)',
    width: '100%',
    margin: 0,
    [theme.breakpoints.up('md')]: {
      position: 'relative',
      top: 'unset',
      borderRadius: 5,
      marginRight: 7,
      paddingLeft: 30,
      paddingRight: 30,
      width: 175,
    },
  },
  form: {
    maxWidth: 600,
    width: '100%',
    borderRadius: theme.shape.borderRadius,
    height: 45,
    [theme.breakpoints.up('md')]: {
      height: 64,
      position: 'relative',
      top: 'unset',
      borderRadius: 5,
    },
  },
  startAdornment: {
    width: 22,
    height: 22,
    position: 'relative',
    bottom: 2,
    marginRight: theme.spacing(1),
    '& path': {
      fill: '#666',
    }
  },
}));
